import { useSettings } from '@/framework/settings';
import { calcCurrency } from '@/lib/use-price';
import classNames from 'classnames';

export const CashbackInfo = ({
  value,
  fullRounded = false,
}: {
  value: number;
  fullRounded?: boolean;
}) => {
  const { settings } = useSettings();

  const { price } = calcCurrency({
    settings: settings as any,
    amount: value,
  });
  return (
    <div
      className={classNames(
        'flex items-center justify-center px-2 py-1 text-[0.6rem] font-semibold leading-none text-blue-800 transform bg-amber-300',
        fullRounded ? 'rounded-full' : 'rounded-lg rounded-b-none',
      )}
    >
      <span className="mr-1">{price}</span>
      <span>Cashback</span>
    </div>
  );
};
